import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setLoading, showMessage} from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';

import CheckBox from '../../widgets/CheckBox';


export function WriterListOfTasks() {
    const [state, setState] = useState({writer:null, errors:{}});
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);


    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getWriter();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getWriter = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/user/`, config);
            showLoading(dispatch, false);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(reply.data.avatar && reply.data.avatar.length === 1) {
                    reply.data.avatar = reply.data.avatar[0];
                }

                setState({
                    ...state,
                    writer: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }
    }

    const updateListOfTasks = async (listOfTasks) => {
        let errorMessage = DEFAULT_ERROR_TEXT;
        
        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
        
        const data = {"listOfTasks" : listOfTasks};

        try {
            const reply = await axios.patch(API_URL + '/user', data, config);
            if(reply.hasOwnProperty('status') && reply.status === API_204) {

            }
        } catch (e) {
            if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                errorMessage = e.response.data["errors"][0];
            }
            if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate)) {
                dispatch(showMessage({message : errorMessage}));
            }
        }


    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            writer:{...state.writer,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const changeList = (listName, id) => {
        let list = state.writer[listName]?? {};
        if(list && list[id]) {
            delete list[id];
        } else {
            list = {...list, [id]: id};
        }
        change(listName, list);
        return list;
    };

    const changeListOfTasks = (id) => {
        let listOfTasks = changeList('listOfTasks', id);
        updateListOfTasks(listOfTasks);
    };

    const openUrlClick = (url) => {
        //navigate("/display-link?url="+url);
           window.open(url, '_blank', 'noopener,noreferrer');
        //   window.open(url, '_self', 'noopener,noreferrer');
    }; 

    return (
        <Frame headerWhite={true} showMenu={true} showNav={true}>
            <div className='main writer-list-of-tasks'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                    <Background >
                        <div className='right-main-inner'>
                            <div className='mt15 text-align-center font-30 font-bold color-550952'>{t("list_of_tasks")}</div>
                            <div className='mt15 text-align-center font-15'>{t("checklist_help_book_publishing")}</div>
                            <div className='mt15 text-align-center font-15'>{t("mark_the_completed_fields")}</div>
                            <div className='mt20 tasks'>
                                <CheckBox id='beta_readers' text={t('beta_readers')} value={state.writer?.listOfTasks?.beta_readers} onChange={(id) => changeListOfTasks(id)} />
                                <img className='tasks-logo' src='/images/back_to.png' alt='' />
                            </div>
                            <div className='mt15 tasks'>
                                <CheckBox id='content_editing' text={t('editing')} value={state.writer?.listOfTasks?.content_editing} onChange={(id) => changeListOfTasks(id)} />
                                <img className='tasks-logo' src='/images/back_to.png' alt='' />
                            </div>
                            <div className='mt15 tasks'>
                                <CheckBox id='technical_editing' text={t('proof_reading')} value={state.writer?.listOfTasks?.technical_editing} onChange={(id) => changeListOfTasks(id)} />
                                <img className='tasks-logo' src='/images/back_to.png' alt='' />
                            </div>
                            <div className='mt15 tasks'>
                                <CheckBox id='cover_design' text={t('cover_design')} value={state.writer?.listOfTasks?.cover_design} onChange={(id) => changeListOfTasks(id)} />
                                <img className='tasks-logo' src='/images/back_to.png' alt='' />
                            </div>
                            <div className='mt15 tasks'>
                                <CheckBox id='typesetting' text={t('page_alignment')} value={state.writer?.listOfTasks?.typesetting} onChange={(id) => changeListOfTasks(id)} />
                                <img className='tasks-logo' src='/images/back_to.png' alt='' />
                            </div>
                            <div className='mt15 tasks'>
                                <CheckBox id='print_houses' text={t('print_houses')} value={state.writer?.listOfTasks?.print_houses} onChange={(id) => changeListOfTasks(id)} />
                                <img className='tasks-logo' src='/images/back_to.png' alt='' />
                            </div>
                            <div className='mt40 text-align-center font-20 color-550952'>{t("our_step_by_step_article_1")}</div>
                            <div className='text-align-center font-20 color-550952'>{t("our_step_by_step_article_2")}</div>
                            <div className="mt20 button-r10 font-bold" onClick={() => openUrlClick("https://www.kotvot.com/post/הוצאת-ספר-לאור-שלבי-הוצאה-לאור-באופן-עצמאי")}>  <div>{t("what_are_publishing_steps")}</div> </div>

                            <div className='mt40 text-align-center font-18 font-bold'>{t("complete_the_checklist")}</div>
                            <div className='mt40 text-align-center font-15'>{t("promote_your_book")}</div>
                            <div className="mt20 button-r10 font-bold" onClick={() => navigateTo(dispatch, navigate, '/marketing-list')}>  <div>{t("marketing_content_creation")}</div> </div>

                            <div className='mb60'></div>
                        </div>
                        
                    </Background>
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}